import { Build, Component, Element, h } from '@stencil/core';

@Component({
  tag: 'staedtler-slider-category',
})
export class SliderCategory {
  @Element() el: HTMLElement;
  swiper;

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }
    const { initializeSlider } = await import('~service/swiper');
    this.swiper = initializeSlider(this.el, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
      slideClass: 'teaser-category',

      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next') as HTMLElement,
        prevEl: this.el.querySelector('.swiper-button-prev') as HTMLElement,
      },

      breakpoints: {
        320: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
        },
        576: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        767: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  render() {
    return [
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <slot />
        </div>
        <a class="swiper-button-prev" role="button">
          <span class="sr-only">Previous</span>
        </a>
        <a class="swiper-button-next" role="button">
          <span class="sr-only">Next</span>
        </a>
      </div>,
    ];
  }
}
